module.exports = __webpack_public_path__ + "static/collage-awards-e9369937cf5fd3b083d82d1c4e5878e4.png";